import { render, staticRenderFns } from "./UnitPlanMarkdownTextField.vue?vue&type=template&id=f8bfd85e&scoped=true&"
import script from "./UnitPlanMarkdownTextField.vue?vue&type=script&lang=js&"
export * from "./UnitPlanMarkdownTextField.vue?vue&type=script&lang=js&"
import style0 from "./UnitPlanMarkdownTextField.vue?vue&type=style&index=0&id=f8bfd85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bfd85e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f8bfd85e', component.options)
    } else {
      api.reload('f8bfd85e', component.options)
    }
    module.hot.accept("./UnitPlanMarkdownTextField.vue?vue&type=template&id=f8bfd85e&scoped=true&", function () {
      api.rerender('f8bfd85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitPlanMarkdownTextField.vue"
export default component.exports